import type { OverrideSourceType } from './types';

/** URL query parameter for parcel overrides */
export const PARCEL_OVERRIDE_URL_PARAM = 'parcel-override' as const;

/** Environment variable for parcel overrides (Webpack DefinePlugin) */
export const PARCEL_OVERRIDE_ENV_KEY = 'PARCEL_OVERRIDES' as const;

/** Window global set by the bridge composable to expose orchestrator overrides */
export const PARCEL_ORCHESTRATOR_GLOBAL = '__ABAX_ORCHESTRATOR_OVERRIDES__' as const;

/** Minimum key length to consider for MF container scope */
export const MIN_SCOPE_KEY_LENGTH = 3;

/** Pattern for identifying MF container scopes on window */
export const DEFAULT_SCOPE_PATTERN = /^@|.*\//;

/** Hostnames considered as localhost for dev detection */
export const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]']);

/** Default Module Federation entry filename */
export const DEFAULT_ENTRY_FILENAME = 'remoteEntry.js' as const;

/** Version validation pattern (semver) */
export const DEFAULT_VERSION_PATTERN = /^\d+\.\d+\.\d+/;

/** Valid port range for localhost URLs */
export const PORT_RANGE = { min: 1, max: 65535 } as const;

/**
 * Override resolution priority order (highest -> lowest).
 * Each parcel scope is independently resolved from the highest-priority source.
 */
export const OVERRIDE_SOURCE_PRIORITY: readonly OverrideSourceType[] = [
  'url',
  'localStorage',
  'orchestrator',
  'env',
] as const;

/** single-spa parcel lifecycle statuses (complete set per single-spa spec) */
export const ParcelStatus = {
  NOT_LOADED: 'NOT_LOADED',
  LOADING_SOURCE_CODE: 'LOADING_SOURCE_CODE',
  NOT_BOOTSTRAPPED: 'NOT_BOOTSTRAPPED',
  BOOTSTRAPPING: 'BOOTSTRAPPING',
  NOT_MOUNTED: 'NOT_MOUNTED',
  MOUNTING: 'MOUNTING',
  MOUNTED: 'MOUNTED',
  UPDATING: 'UPDATING',
  UNMOUNTING: 'UNMOUNTING',
  UNLOADING: 'UNLOADING',
  SKIP_BECAUSE_BROKEN: 'SKIP_BECAUSE_BROKEN',
  LOAD_ERROR: 'LOAD_ERROR',
} as const;

export type ParcelStatusType = (typeof ParcelStatus)[keyof typeof ParcelStatus];

/** Check if a parcel is in an error/broken state */
export function isParcelBroken(status: ParcelStatusType): boolean {
  return status === ParcelStatus.SKIP_BECAUSE_BROKEN || status === ParcelStatus.LOAD_ERROR;
}
